import './Checkbox.scss';
import Component from './Checkbox.js';
export default Component;
